type Props = {
  currentIndex: number
  totalItems: number
}

const DotsIndicator = ({ currentIndex, totalItems }: Props) => {
  const dots = Array.from({ length: totalItems }, (_, index) => index)

  return (
    <div className="van-offer-dots-indicator">
      {dots.map(index => (
        <div
          key={index}
          className={`van-offer-dot ${index === currentIndex ? 'van-offer-dot--active' : ''}`}
        />
      ))}
    </div>
  )
}

export default DotsIndicator
